@if (booking) {
  <div class="surface-card border-round shadow-2 mb-4 p-4">
    <div class="flex flex-wrap gap-3">
      @if (booking.start_date && booking.end_date) {
        <span class="border-round shadow-1 inline-flex content-center bg-primary-100 px-3 pb-2 pt-[9px] text-sm text-primary-900">
          <i class="pi pi-calendar mr-2"></i>
          <strong>{{ formattedStartDate }}</strong>
          <i class="pi pi-arrow-right mx-2 mt-[2px] inline-block text-xs"></i>
          <strong>{{ formattedEndDate }}</strong>
          <span class="border-round ml-2 bg-primary-50 px-2 pt-[1px] text-xs text-primary-800">
            {{ stayDuration }} {{ 'booking.detail.nights' | translate }}
          </span>
        </span>
      }

      <span class="border-round shadow-1 inline-flex content-center bg-blue-100 px-3 py-[9px] pb-2 text-sm text-blue-900">
        <i class="pi pi-users mr-2 leading-[14px]"></i>
        <strong class="leading-[14px]"
          >{{ (booking.adult_occupants || 0) + (booking.child_occupants || 0) }} {{ 'booking.detail.guests' | translate }}</strong
        >
        @if (booking.child_occupants && booking.child_occupants > 0) {
          <span class="ml-1 leading-[14px]">
            ({{ booking.child_occupants }}
            {{ booking.child_occupants === 1 ? ('booking.detail.child' | translate) : ('booking.detail.children' | translate) }})
          </span>
        }
      </span>

      @if (booking.number_of_rooms) {
        <span class="align-items-center border-round shadow-1 flex bg-orange-100 px-3 py-[8px] text-sm text-orange-900">
          <i class="pi pi-home mr-2 leading-[14px]"></i>
          <strong class="leading-[14px]">
            {{ booking.number_of_rooms }}
            {{ booking.number_of_rooms === 1 ? ('booking.detail.room' | translate) : ('booking.detail.rooms' | translate) }}
          </strong>
        </span>
      }

      <span
        class="flex align-items-center px-3 py-[8px] text-sm {{
          booking.paid ? 'bg-green-100 text-green-900' : 'bg-red-100 text-red-900'
        }} border-round shadow-1"
        style="vertical-align: middle"
      >
        <i class="pi {{ booking.paid ? 'pi-check-circle' : 'pi-exclamation-circle' }} mr-2 block leading-[14px]"></i>
        <strong class="leading-[14px]">{{ booking.paid ? ('booking.detail.paid' | translate) : ('booking.detail.unpaid' | translate) }}</strong>
        @if (booking.booking_price && booking.currency?.name) {
          <span class="ml-2 font-semibold leading-[14px]"> {{ booking.booking_price }} {{ booking.currency?.name }} </span>
        }
      </span>

      @if (booking.bookingSource?.name) {
        <span class="align-items-center border-round shadow-1 inline-flex bg-purple-100 px-3 py-[9px] pb-2 text-sm text-purple-900">
          <i class="pi pi-globe mr-2 leading-[14px]"></i>
          <strong class="leading-[14px]">{{ booking.bookingSource?.name }}</strong>
        </span>
      }

      <app-login-token [token]="booking.login_token"></app-login-token>
    </div>
  </div>
}
